import FoodstandAuthContainer from './containers/FoodstandAuthContainer'
export default FoodstandAuthContainer
